import React, { useEffect, useState } from "react";
import RadioButtonCard from "components/radioButtonCard/RadioButtonCard";
import Spacer from "components/Spacer/Spacer";
import Button from "components/buttons/Button";
import useModal from "hooks/useModal";
import AddChildModal from "../../common/AddChildModal";
import { usePrimaryCareVisitFlow } from "hooks/useVisitFlow";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { primaryCareVisitFlowReducers } from "reducers/primary_care/primaryCareVisitFlowReducer";
import { primary_care_sub_steps } from "helpers/enum";

function SelectChild({
  incompleteData,
  createNewVisit,
  creatingVisit,
  updateVisit,
  updatingVisit,
  setActiveIndex,
  goBackToSelf,
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { setShowModal } = useModal();
  const [selected, setSelected] = useState(null);
  const { patientsList, subSteps } = usePrimaryCareVisitFlow();
  const currentScreenValueFromStore =
    subSteps[primary_care_sub_steps.select_child].value;

  useEffect(() => {
    if (currentScreenValueFromStore) {
      setSelected(currentScreenValueFromStore);
    } else {
      if (
        patientsList?.filter(
          (patient) =>
            patient?.relationship_with_account &&
            patient.relationship_with_account === "pappa"
        ).length === 1
      ) {
        setSelected(
          patientsList?.filter(
            (patient) =>
              patient?.relationship_with_account &&
              patient.relationship_with_account === "pappa"
          )[0].full_name
        );
      }
    }
  }, [currentScreenValueFromStore, patientsList]);

  function onRightButtonClick() {
    if (incompleteData && Object.keys(incompleteData)?.length) {
      updateVisit({
        payload: {
          case: {
            id: incompleteData?.id,
            patient_id: patientsList?.find((el) => el?.full_name === selected)
              ?.id,
            allergies: incompleteData?.allergies_json,
            medications:
              typeof incompleteData?.medications[0] === "string"
                ? incompleteData?.medications.map((item) => ({
                    name: item,
                  }))
                : incompleteData?.medications,
            primary_care_steps: incompleteData?.primary_care_steps,
          },
        },
        change_current_screen: false,
        screen_to_complete: null,
        callBack: () => {
          dispatch(
            primaryCareVisitFlowReducers.select_child({
              value: selected,
            })
          );
          setActiveIndex(1);
          history.push("/visit/primary-care/pricing");
        },
      });
    } else {
      createNewVisit({
        patient_id: patientsList?.find((el) => el?.full_name === selected)?.id,
        change_current_screen: false,
        screen_to_complete: null,
        callBack: () => {
          dispatch(
            primaryCareVisitFlowReducers.select_child({
              value: selected,
            })
          );
          setActiveIndex(1);
          history.push("/visit/primary-care/pricing");
        },
      });
    }
  }
  return (
    <>
      <RadioButtonCard
        loading={creatingVisit}
        options={patientsList
          ?.filter(
            (patient) =>
              patient?.relationship_with_account &&
              patient.relationship_with_account === "pappa"
          )
          ?.map((el) => el?.full_name)}
        onSelect={setSelected}
        selected={selected}
      />
      <Spacer height="38" />
      <Button
        disabled={updatingVisit}
        onClick={() => {
          setShowModal({
            state: true,
            children: (_, onClose) => (
              <AddChildModal
                onClose={(e) => {
                  if (e !== null) {
                    setSelected(e);
                  }
                  onClose();
                }}
              />
            ),
            data: null,
          });
        }}
        label="Add Child"
        outlined
      />
      <div className="flex justify-between items-center">
        <Button
          className="flex-1 py-4 mt-10"
          label="Back"
          onClick={goBackToSelf}
        />
        <Spacer width={25} />
        <Button
          disabled={!selected}
          className="flex-1 py-4 mt-10"
          loading={updatingVisit || creatingVisit}
          label="Next"
          onClick={onRightButtonClick}
        />
      </div>
    </>
  );
}

export default SelectChild;
